import { render, staticRenderFns } from "./LoanPerformanceTotalDetail.vue?vue&type=template&id=a900975c&scoped=true&"
import script from "./LoanPerformanceTotalDetail.vue?vue&type=script&lang=js&"
export * from "./LoanPerformanceTotalDetail.vue?vue&type=script&lang=js&"
import style0 from "./LoanPerformanceTotalDetail.vue?vue&type=style&index=0&id=a900975c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a900975c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VFlex,VRow})
